<script>
    import Signup from '../services/signup.js'
    import router from "page";
    import { onMount } from "svelte"
    import { notifications } from '../services/notification'
    import ToastComponent from '../components/ToastComponent.svelte'

    let username = null
    let password = null
    let type = "create"

    export let params
    
    onMount(async () => {

        try {
            console.log("UID", params)
            let result = await Signup.initiate(params.uid)

            console.log('RES', result)
            if(result.success) {
                username = result.data.username
                type = result.data.type
            }
            if(!result.success) notifications.danger(result.data.message)
           
        } catch(e) {
            notifications.danger(result.data.message)
        }


    })

    const create = async () => {

        try {
            let result = await Signup.create(params.uid, { username : username, password : password })
            console.log("CREATE", result)

            if(result.success) router.redirect('/login')
            if(!result.success) notifications.danger(result.data.message)
        } catch(e) {
            notifications.danger(result.data.message)
        }

    }

    const reset = async () => {

        try {
            let result = await Signup.reset(params.uid, { username : username, password : password })
            console.log("CREATE", result)

            if(result.success) router.redirect('/login')
            if(!result.success) notifications.danger(result.data.message)
        } catch(e) {
            notifications.danger(result.data.message)
        }

    }
    
</script>

<h2 class="mb-6 text-center text-white mt-5 mb-5">Compte</h2>


<div class="row justify-content-center mt-3 mb-3">
    <div class="col-md-6 my-card">

        <div class="text-center mt-4">
            <input type="text" bind:value={username} class="p-2" placeholder="Entrez un pseudo" disabled/>
            <p class="subtitle">Cet identifiant vous a été attribué automatiquement.</p>
        </div>

        <div class="text-center mt-4">
            <input type="password" bind:value={password} class="p-2" placeholder="Entrez un mot de passe"/>
        </div>

        {#if type === "reset"}
        <div class="text-center mt-4">
            <button type="button" on:click={reset} class="btn btn-light">Réinitialiser</button>
        </div>
        {:else}
        <div class="text-center mt-4">
            <button type="button" on:click={create} class="btn btn-light">Créer un compte</button>
        </div>
        {/if}

    </div>

</div>

<ToastComponent></ToastComponent>

<style>
    .my-card {
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.3);
        border-radius: 10px;
        padding: 15px 5px;
        color: #000;
        background-color: #ffffffa1;
    }

    .subtitle {
        max-width: 220px;
        margin-left: calc(50% - 110px);
        text-align: left;
        font-size: 12px;
        font-weight: 600;
    }

</style>





